import { render, staticRenderFns } from "./MedicalCertificateUpsertForm.vue?vue&type=template&id=d22654f4"
import script from "./MedicalCertificateUpsertForm.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificateUpsertForm.vue?vue&type=script&lang=ts"
import style0 from "./MedicalCertificateUpsertForm.vue?vue&type=style&index=0&id=d22654f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports